
const CollegeSvg = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M46 41L46 128" stroke="#0085FF" />
      <path
        d="M114 22.6825L81.8426 14L14 32.3175M114 22.6825L46.1574 41L14 32.3175M114 22.6825V128M14 32.3175V128"
        stroke="#0085FF"
      />
      <path
        d="M102.5 128C102.5 128 102.5 107.999 102.5 77.4997C102.5 47 58 58.4985 58 86.9993C58 115.5 58 127.999 58 127.999"
        stroke="#0085FF"
      />
      <path d="M14 48.9998L46 57.5741L114 39.3535" stroke="#0085FF" />
      <path
        d="M73 128C73 128 73.5 74.5 73.5 70C73.5 65.5 72 63 72 63"
        stroke="#0085FF"
      />
    </svg>
  );
};

export default CollegeSvg;
